
export class Response {

	data : any;
 	status : number;
    code: number;
 	message :string[] = [];

}
